import { usePermissions } from "components/context/permissionsContext";

export const useCommunicationLogPermission = () => {
  const { userPermissions } = usePermissions();

  const hasCommunicationSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "CommunicationLog" &&
      item.identifier === "communicationlog-savecommunicationlog" &&
      item.hasPermission
  );
  const hasCommunicationGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "CommunicationLog" &&
      item.identifier === "communicationlog-getcommunicationlog" &&
      item.hasPermission
  );
  const hasCommunicationDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "CommunicationLog" &&
      item.identifier === "communicationlog-deletecommunicationlog" &&
      item.hasPermission
  );

  const CommunicationPermissionProps = {
    hasCommunicationSavePermission,
    hasCommunicationGetPermission,
    hasCommunicationDeletePermission,
  };

  return {
    CommunicationPermissionProps,
  };
};
